<template>
  <div style="margin-top: -13px">
    <v-container fluid>
      <v-card elevation="0" style="min-height: 100px">
        <v-form novalidate ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="6" lg="6" class="mt-4 mx-5">
              <v-btn
                class="mx-0 font-weight-light"
                color="error lighten-2"
                text
                @click="deleteAccount"
              >
                Eliminar conta
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import eventBus from "../../../../main";

export default {
  name: "SectionDeleteAccount",
  methods: {
    deleteAccount() {
      eventBus.$emit("openDeleteEntity", true);
    }
  }
};
</script>

<style scoped></style>
